import { useQuery } from "@tanstack/react-query";
import { useChatStore } from "../../stores/chat-store-context";
import { sessionConnectorsQueryOptions } from "../../queries/connectors-queries";

/**
 * Look up the human-readable MCP `Tool.title` for an agent-facing tool name
 * (e.g. `post-copy_send_message`). Returns `null` if the tool is not from
 * an MCP connector (system tool), or the connector hasn't started yet, or
 * the server didn't advertise a title.
 *
 * Reads from the `sessionConnectorsQueryOptions` cache, which is already
 * populated by `HeroConnectorsPill` when the chat opens — so this hook
 * doesn't trigger an extra request, it just subscribes to the same query.
 */
export function useMcpToolTitle(toolName: string): string | null {
  const sessionId = useChatStore((s) => s.activeSessionId);
  const { data } = useQuery({
    ...sessionConnectorsQueryOptions(sessionId),
    select: (resp) => {
      for (const c of resp.connectors) {
        for (const t of c.tools ?? []) {
          if (t.name === toolName) return t.title ?? null;
        }
      }
      return null;
    },
  });
  return data ?? null;
}
